// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportProgressList.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { uniqueId } from 'lodash/fp';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import { IMPORT_PROGRESS_LIST_MAX_HEIGHT } from 'logic/data/Izenda.ImportConstants';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import ImportProgressViewItem from './Izenda.ImportProgressViewItem';
import { observer } from 'mobx-react';

@observer
export default class ImportProgressList extends Component {
  isScrollBoxDirty: boolean = false;

  setScrollBox = (dom: any) => {
    this.scrollBox = dom;
  };

  onScroll = () => {
    this.isScrollBoxDirty = true;
  };

  onUpdateStatus = (dom: any) => {
    if (!this.isScrollBoxDirty) {
      const currentScrollTop = this.scrollBox.getScrollTop();
      const itemOffsetTop = dom.offsetTop;
      itemOffsetTop > currentScrollTop && this.scrollBox.scrollTo({ left: 0, top: itemOffsetTop });
    }
  };

  render() {
    const { importProgressList } = this.props;

    return (
      <ScrollBox
        ref={this.setScrollBox}
        viewClassName="izenda-ImportProgressPopup"
        autoHeight
        autoHeightMax={IMPORT_PROGRESS_LIST_MAX_HEIGHT}
        triggerOnScrollWhenScrollTo={false}
        onScroll={this.onScroll}
      >
        <GridLayout className="izenda-ImportProgressList">
          {importProgressList.map(item => {
            return <ImportProgressViewItem key={uniqueId()} onUpdateStatus={this.onUpdateStatus} item={item} />;
          })}
        </GridLayout>
      </ScrollBox>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/Popup/Izenda.ImportProgressList.js